// Reference-counted so nested overlays (e.g. a confirm modal opened on top of an
// edit modal) don't clobber each other's saved state. Only the outermost
// lock/unlock pair actually touches the body — inner calls just adjust the count.
let lockCount = 0;
let scrollPosition = 0;
let previousOverflow = '';

export const lockScroll = () => {
    lockCount += 1;
    if (lockCount > 1) return;
    scrollPosition = window.pageYOffset;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';
    document.body.style.height = '100dvh';
};

export const isScrollLocked = () => lockCount > 0;

export const unlockScroll = () => {
    if (lockCount === 0) return;
    lockCount -= 1;
    if (lockCount > 0) return;
    document.body.style.overflow = previousOverflow;
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('height');
    window.scrollTo(0, scrollPosition);
};
